import { defineStore } from 'pinia'
import { computed } from 'vue'
import { createIndexedDBStore } from '@/stores/_base/createIndexedDBStore'
import { createBankTransactionService } from '@/services'
import type { BankTransaction } from '@farmfree/common/types/bank/bankTransaction'

// 기본 Store 팩토리 생성
const baseBankTransactionStore = createIndexedDBStore<BankTransaction>({
  storeId: 'bankTransaction',
  tableName: 'bank-transactions',
  versionField: 'bankTransactionVersion',
  service: createBankTransactionService(),
})

// 정렬된 items를 반환하는 확장 Store
export const useBankTransactionStore = defineStore('bankTransactionExtended', () => {
  const store = baseBankTransactionStore()

  // 원본 items를 날짜순 정렬 (오래된 것부터 → 최신 것 순)
  const sortedItems = computed(() => {
    return [...store.items].sort((a, b) => {
      // dateCreated를 밀리초로 변환하여 비교
      const aTime = typeof a.dateCreated === 'number' ? a.dateCreated : a.dateCreated.toMillis()
      const bTime = typeof b.dateCreated === 'number' ? b.dateCreated : b.dateCreated.toMillis()
      return aTime - bTime // 오름차순: 오래된 거래가 위, 최신 거래가 아래
    })
  })

  return {
    ...store,
    items: sortedItems, // 정렬된 items로 대체
  }
})
